import { useCallback } from "react";
import { useSignal } from "@preact/signals-react";
import { DEFAULT_ALLOWZOMMORPAN } from "../conts";

export function useHomeToolBarState() {
  const allowZoomOrPan = useSignal(DEFAULT_ALLOWZOMMORPAN);
  const figmaMode = useSignal(false);

  const setAllowZoomOrPan = useCallback((value: boolean) => {
    allowZoomOrPan.value = value;
  }, []);

  const setFigmaMode = useCallback((value: boolean) => {
    figmaMode.value = value;
  }, []);
  return {
    setAllowZoomOrPan,
    setFigmaMode,
    allowZoomOrPan: allowZoomOrPan.value,
    figmaMode: figmaMode.value,
  };
}
